/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    GuidIdAndLabel,
    GuidIdAndLabelFromJSON,
    GuidIdAndLabelFromJSONTyped,
    GuidIdAndLabelToJSON,
    GuidIdCodeAndLabel,
    GuidIdCodeAndLabelFromJSON,
    GuidIdCodeAndLabelFromJSONTyped,
    GuidIdCodeAndLabelToJSON,
    Int32IdAndLabel,
    Int32IdAndLabelFromJSON,
    Int32IdAndLabelFromJSONTyped,
    Int32IdAndLabelToJSON,
} from './';

/**
 * 
 * @export
 * @interface AncillarySupplierFormData
 */
export interface AncillarySupplierFormData {
    /**
     * 
     * @type {string}
     * @memberof AncillarySupplierFormData
     */
    id?: string | null;
    /**
     * 
     * @type {GuidIdAndLabel}
     * @memberof AncillarySupplierFormData
     */
    supplier?: GuidIdAndLabel;
    /**
     * 
     * @type {GuidIdCodeAndLabel}
     * @memberof AncillarySupplierFormData
     */
    carrier?: GuidIdCodeAndLabel;
    /**
     * 
     * @type {GuidIdAndLabel}
     * @memberof AncillarySupplierFormData
     */
    ancillary?: GuidIdAndLabel;
    /**
     * 
     * @type {Int32IdAndLabel}
     * @memberof AncillarySupplierFormData
     */
    ancillaryCategory?: Int32IdAndLabel;
    /**
     * 
     * @type {string}
     * @memberof AncillarySupplierFormData
     */
    ancillarySupplierCode?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof AncillarySupplierFormData
     */
    allowEdit?: boolean;
}

export function AncillarySupplierFormDataFromJSON(json: any): AncillarySupplierFormData {
    return AncillarySupplierFormDataFromJSONTyped(json, false);
}

export function AncillarySupplierFormDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): AncillarySupplierFormData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'supplier': !exists(json, 'supplier') ? undefined : GuidIdAndLabelFromJSON(json['supplier']),
        'carrier': !exists(json, 'carrier') ? undefined : GuidIdCodeAndLabelFromJSON(json['carrier']),
        'ancillary': !exists(json, 'ancillary') ? undefined : GuidIdAndLabelFromJSON(json['ancillary']),
        'ancillaryCategory': !exists(json, 'ancillaryCategory') ? undefined : Int32IdAndLabelFromJSON(json['ancillaryCategory']),
        'ancillarySupplierCode': !exists(json, 'ancillarySupplierCode') ? undefined : json['ancillarySupplierCode'],
        'allowEdit': !exists(json, 'allowEdit') ? undefined : json['allowEdit'],
    };
}

export function AncillarySupplierFormDataToJSON(value?: AncillarySupplierFormData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'supplier': GuidIdAndLabelToJSON(value.supplier),
        'carrier': GuidIdCodeAndLabelToJSON(value.carrier),
        'ancillary': GuidIdAndLabelToJSON(value.ancillary),
        'ancillaryCategory': Int32IdAndLabelToJSON(value.ancillaryCategory),
        'ancillarySupplierCode': value.ancillarySupplierCode,
        'allowEdit': value.allowEdit,
    };
}


